<div class="table-responsive m-b">
  <table class="table table-middle m-b-none">
    <thead>
      <tr>
        <th class="table-title">
          <i class="mdi mdi-alert-circle mx-1"></i>
          <h2 class="title">Observações</h2>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <ul class="f-14">
            <li class="text-secondary format-compacta">
              Sempre verifique o site do detran do estado em que o veículo foi emplacado pois podem ocorrer divergências
              entre as bases consultadas.
            </li>
            <li class="text-secondary format-compacta">
              Esta consulta não contém dados do RNS.
            </li>
            <li class="text-secondary format-compacta">
              Verifique o documento do veículo para outras restrições, observações ou CSV.
            </li>
            <li class="text-secondary format-compacta">
              Uso exclusivo da empresa associada para auxílio na aprovação de crédito.
            </li>
            <li class="text-secondary format-compacta">
              A divulgação de tais informações a terceiros sujeitará o infrator as sanções penais.
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</div>